var map = {
	"./adult/nn/tulleord-data.json": 774,
	"./adult/no/tulleord-data.json": 775,
	"./adult/se/tulleord-data.json": 776,
	"./youth/de/tulleord-data.json": 777,
	"./youth/nn/tulleord-data.json": 778,
	"./youth/no/tulleord-data.json": 779,
	"./youth/se/tulleord-data.json": 780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 773;